package com.tovtalk.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import kotlin.Long
import kotlin.String

public class AnalyticsEventsQueueQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun loadAll(): Query<String> = Query(-1_437_696_688, arrayOf("AnalyticsEventQueueEntity"),
      driver, "AnalyticsEventsQueue.sq", "loadAll",
      "SELECT payload_json FROM AnalyticsEventQueueEntity ORDER BY created_at ASC") { cursor ->
    cursor.getString(0)!!
  }

  public fun countRows(): Query<Long> = Query(1_343_000_765, arrayOf("AnalyticsEventQueueEntity"),
      driver, "AnalyticsEventsQueue.sq", "countRows",
      "SELECT COUNT(*) FROM AnalyticsEventQueueEntity") { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public fun appendOrReplace(
    event_id: String,
    payload_json: String,
    created_at: Long,
  ): QueryResult<Long> {
    val result = driver.execute(-409_599_284, """
        |INSERT OR REPLACE INTO AnalyticsEventQueueEntity(event_id, payload_json, created_at)
        |VALUES (?, ?, ?)
        """.trimMargin(), 3) {
          bindString(0, event_id)
          bindString(1, payload_json)
          bindLong(2, created_at)
        }
    notifyQueries(-409_599_284) { emit ->
      emit("AnalyticsEventQueueEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun removeById(event_id: String): QueryResult<Long> {
    val result = driver.execute(828_679_137,
        """DELETE FROM AnalyticsEventQueueEntity WHERE event_id = ?""", 1) {
          bindString(0, event_id)
        }
    notifyQueries(828_679_137) { emit ->
      emit("AnalyticsEventQueueEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun clearAll(): QueryResult<Long> {
    val result = driver.execute(1_621_272_639, """DELETE FROM AnalyticsEventQueueEntity""", 0)
    notifyQueries(1_621_272_639) { emit ->
      emit("AnalyticsEventQueueEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteOldestExcess(keepCount: Long): QueryResult<Long> {
    val result = driver.execute(-741_679_094, """
        |DELETE FROM AnalyticsEventQueueEntity
        |WHERE event_id IN (
        |    SELECT event_id FROM AnalyticsEventQueueEntity
        |    ORDER BY created_at ASC
        |    LIMIT (SELECT MAX(0, (SELECT COUNT(*) FROM AnalyticsEventQueueEntity) - ?))
        |)
        """.trimMargin(), 1) {
          bindLong(0, keepCount)
        }
    notifyQueries(-741_679_094) { emit ->
      emit("AnalyticsEventQueueEntity")
    }
    return result
  }
}
